class TeaserAltCarousel {
    constructor(el) {
        this.scope = el;
        this.items = el.querySelector('[data-items]');
        this.prevButton = el.querySelector('[data-prev]');
        this.nextButton = el.querySelector('[data-next]');
        this.navContainer = el.querySelector('[data-slider-nav]');
        this.slider = new Slider(
            this.scope, 
            this.items, 
            {
                controls:[
                    this.prevButton, this.nextButton
                ],
                navContainer: this.navContainer, 
                count:[2, 3, 3]
            }
        );
    }
}
document.querySelectorAll('[data-teaser-alt-carousel]').forEach(el => new TeaserAltCarousel(el));

